enum PATHS {
  ROOT = '/',

  // AUTH
  LOGIN = '/login',
  REGISTRATION = '/registration',
  FORGOT_PASSWORD = '/forgot-password-email',
  FORGOT_PASSWORD_SENT = '/forgot-password-sent',
  RESET_PASSWORD = '/forgot-password/:token',
  RESET_PASSWORD_CHANGED = '/forgot-password-changed',
  CONFIRMATION = '/confirm-registration',
  CONFIRMATION_EXPIRED = '/confirm-expired',
  CONFIRMATION_RESULT = '/confirm-registration/:token',

  WELCOME = '/welcome',

  // COMPANY MEMBERS
  COMPANY_MEMBERS = '/company-members',

  // MANAGE ORGANIZATION
  MANAGE_ORGANIZATION = '/manage-organization',
  MANAGE_ORGANIZATION_GENERAL_INFORMATION = '/manage-organization/general-information',
  MANAGE_ORGANIZATION_USER_MANAGEMENT = '/manage-organization/user-management',
  MANAGE_ORGANIZATION_DEPARTMENT_MANAGEMENT = '/manage-organization/department-management',
  MANAGE_ORGANIZATION_SUBSCRIPTION_MANAGEMENT = '/manage-organization/subscription-management',

  // Profile Settings
  PROFILE_SETTINGS = '/profile-settings',
  PROFILE_SETTINGS_GENERAL_DATA = '/profile-settings/general-data',

  // EXPERTISE MANAGEMENT
  EXPERTISE_MANAGEMENT = '/expertise-management',
  EXPERTISE_MANAGEMENT_FROM_SCRATCH = '/expertise-management-from-scratch',

  // KNOWLEDGE AREA MANAGEMENT
  KNOWLEDGE_AREA = '/knowledge-area',
  KNOWLEDGE_AREA_FROM_SCRATCH = '/knowledge-area-from-scratch',

  // USER PROFILE
  USER_PROFILE = '/user-profile',
  USER_PROFILE_KNOWLEDGE_AREA_DETAILS = 'knowledge-area-details',
  USER_SETTINGS = '/user-settings',

  // DASHBOARD
  DASHBOARD = '/dashboard',
  DASHBOARD_READINESS = '/dashboard/readiness',
  DASHBOARD_READINESS_DETAIL = '/dashboard/readiness/:positionId',
  DASHBOARD_READINESS_SKILL = '/dashboard/readiness/:positionId/:kaId',
  DASHBOARD_LEARNERS = '/dashboard/learners',
  DASHBOARD_STALLED = '/dashboard/stalled',
  DASHBOARD_ACTIVITY = '/dashboard/activity',
  DASHBOARD_PRIORITIES = '/dashboard/priorities',
}

export { PATHS };
